export function getDetailedTime(time: number | null) {
  if (!time) {
    return { hours: '--', minutes: '--', seconds: '--' }
  }

  const hours = Math.floor(time / 1000 / 60 / 60)
  const minutes = Math.floor((time / 1000 / 60) % 60)
  const seconds = Math.floor((time / 1000) % 60)

  return { hours, minutes, seconds }
}
